"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressPlacesAutocomplete = void 0;

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

var _components = require("@qsite/components");

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _reactPlacesAutocomplete = _interopRequireWildcard(require("react-places-autocomplete"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledList = _styledComponents["default"].ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tcursor: pointer;\n\tpadding: 0;\n\tmargin: 0;\n"])));

var StyledItem = _styledComponents["default"].li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tlist-style-type: none;\n\tcolor: black;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n"])), function (_ref) {
  var active = _ref.active;
  return active ? '#a3a3a3' : '#ffffff';
}); // Commented code below is just for temporary reference
// const fieldNamesToTypesCorrelation = [
// 	{ googleType: 'formatted_address', fieldName: 'address1' },
// 	{ googleType: 'locality', fieldName: 'suburb' },
// 	{ googleType: 'administrative_area_level_1', fieldName: 'state' },
// 	{ googleType: 'postal_code', fieldName: 'postcode' },
// ];


var AddressPlacesAutocomplete = function AddressPlacesAutocomplete(_ref2) {
  var field = _ref2.field,
      form = _ref2.form,
      ariaRequired = _ref2.ariaRequired,
      id = _ref2.id,
      className = _ref2.className,
      suggestionsHelpTempStrings = _ref2.suggestionsHelpTempStrings,
      loadingText = _ref2.loadingText;
  var i18n = (0, _reactI18next.useTranslation)();

  function mapAddressComponentTypes(components, formattedAddress) {
    // This function will look for an address component named 'locality' (which is the suburb)
    // and extract everything that comes before it to fill in the "Address 1" field on the form
    // The rest of the address components are filled according to the mapping below:
    // locality = suburb
    // postal_code = postcode
    // administrative_area_level_1 = state
    components.forEach(function (component) {
      var addressComponent = component.types[0];

      switch (addressComponent) {
        case 'locality':
          var suburb = component.short_name;
          var address1Field = formattedAddress.split(", ".concat(suburb))[0];
          form.setFieldValue('address1', address1Field);
          form.setFieldValue('suburb', suburb);
          break;

        case 'postal_code':
          var postalCode = component.short_name;
          form.setFieldValue('postcode', postalCode);
          break;

        case 'administrative_area_level_1':
          var state = component.short_name;
          form.setFieldValue('state', state);
          break;

        default:
          break;
      }
    });
  }

  function handleSelect(address) {
    (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (res) {
      var _res = _slicedToArray(res, 1),
          _res$ = _res[0],
          address_components = _res$.address_components,
          formatted_address = _res$.formatted_address;

      mapAddressComponentTypes(address_components, formatted_address);
    });
  }

  function handleAutoCompleteChange(_ref3) {
    var name = _ref3.name,
        form = _ref3.form,
        search = _ref3.search,
        id = _ref3.id;
    form.setFieldValue(name, search);
    document.getElementById(id).removeAttribute('aria-activedescendant');
  }

  return /*#__PURE__*/_react["default"].createElement(_reactPlacesAutocomplete["default"], {
    value: field.value,
    onChange: function onChange(search) {
      handleAutoCompleteChange({
        name: field.name,
        id: field.name,
        form: form,
        search: search
      });
    },
    onSelect: handleSelect,
    searchOptions: {
      componentRestrictions: {
        country: ["au"]
      },
      types: ['address']
    }
  }, function (_ref4) {
    var getInputProps = _ref4.getInputProps,
        getSuggestionItemProps = _ref4.getSuggestionItemProps,
        suggestions = _ref4.suggestions,
        loading = _ref4.loading;
    var additionalProps = {
      name: field.name,
      id: field.name,
      className: 'location_search_input',
      placeholder: i18n.t('shippingInfo.address_1')
    };
    var autocompleteInputProps = getInputProps(additionalProps);
    var suggestionHelp = '';

    if (!_lodash["default"].isEmpty(suggestions)) {
      // ! TEMPORARY CODE
      try {
        suggestionHelp = "".concat(suggestionsHelpTempStrings.suggestionsHelpTemp1, " ").concat(suggestions.length, " ").concat(suggestionsHelpTempStrings.suggestionsHelpTemp2);
      } catch (error) {
        console.error(error);
      }
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "autocomplete-root"
    }, /*#__PURE__*/_react["default"].createElement(_components.Input, _extends({}, autocompleteInputProps, {
      icon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proLightSvgIcons.faAddressBook
      }),
      autoComplete: "no",
      "aria-owns": "autocomplete-dropdown-container",
      hintElement: /*#__PURE__*/_react["default"].createElement("div", {
        id: "suggestions-help",
        className: "sr-only",
        role: "status",
        "aria-atomic": "true",
        "aria-live": "assertive"
      }, suggestionHelp),
      "aria-activedescendant": null,
      ariaRequired: ariaRequired,
      id: id,
      className: className
    })), loading && /*#__PURE__*/_react["default"].createElement("div", null, loadingText), /*#__PURE__*/_react["default"].createElement(StyledList, {
      id: "autocomplete-dropdown-container",
      className: "autocomplete-dropdown-container",
      role: "listbox"
    }, suggestions.map(function (suggestion, i) {
      if (suggestion.active) {
        document.getElementById(autocompleteInputProps.id).setAttribute('aria-activedescendant', "suggestion_item--".concat(i + 1));
      }

      return /*#__PURE__*/_react["default"].createElement(StyledItem, _extends({}, getSuggestionItemProps(suggestion, {
        className: 'suggestion_item'
      }), {
        active: suggestion.active,
        id: "suggestion_item--".concat(i + 1),
        key: suggestion.placeId,
        "aria-selected": suggestion.active
      }), suggestion.description);
    })));
  });
};

exports.AddressPlacesAutocomplete = AddressPlacesAutocomplete;